<style lang="scss" scoped>
.warning-title {
  display: flex;
  justify-content: center;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #303c54;
  img {
    margin-right: 10px;
  }
}
.modal-content {
  border: none;
}
@media only screen and (max-width: 768px) {
  .mobile-input {
    margin-top: 15px;
  }
  .mobile-header {
    margin-bottom: 0;
  }
  .approval-overtime {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .row-mobile {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .col-mobile {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .image-evidence {
    width: 100% !important;
  }
}
.image-evidence {
  width: 100% !important;
}
.approval-overtime {
  .col-md-10.offset-md-2 {
    margin: auto;
  }

  td.comment {
    max-width: 300px;
    word-wrap: break-word;
  }

  .save-info {
    border-radius: 10px;
    width: 210px;
    height: 40px;
    background-color: #3d4cdc;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    margin-right: 10px;
  }

  label {
    font-weight: 600;
  }

  .input-group {
    margin-bottom: 0px !important;
  }

  .cancel-btn {
    border-radius: 10px;
    width: 210px;
    height: 40px;
    font-weight: 700;
    font-size: 14px;
    background-color: #ececec;
    color: #6f6f6f;
  }

  span.require {
    color: #ff1a1a;
  }

  span.required {
    color: #ff1a1a;
    margin-top: -15px;
  }

  .submit-form {
    margin-top: 30px;
    text-align: center;
  }

  .bg-text {
    margin-bottom: 15px;
  }

  @media screen and (max-width: 420px) {
    .save-info {
      display: block;
      width: 100%;
      margin-top: 10px;
    }
    .cancel-btn {
      width: 100%;
      //max-width: 420px;
      margin-top: 5px;
    }
    .mobile-header {
      margin-bottom: 0;
    }
    .mobile-input {
      margin-top: 15px;
    }
    .image-evidence {
      width: 100% !important;
    }
  }
  .modal-content {
    border: none;
    .warning-title {
      display: flex;
      justify-content: center;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #303c54;
      img {
        margin-right: 10px;
      }
    }
  }
}
</style>

<template>
  <div class="approval-overtime">
    <CRow>
      <CCol md="6" class="form-field">
        <label>{{ $t("label.employee_code") }}</label>
        <div class="form-control bg-text">
          {{ dataForm.employee ? dataForm.employee.id : "" }}
        </div>
      </CCol>
      <CCol md="6" class="form-field">
        <label>{{ $t("label.full_name") }}</label>
        <div class="form-control bg-text">
          {{ dataForm.employee ? dataForm.employee.name : "" }}
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6" class="form-field">
        <label>{{ $t("fields.additional_timeSheet.request_date") }}</label>
        <div class="form-control bg-text">
          {{ dataForm.work_date | formatDate }}
        </div>
      </CCol>
      <CCol md="6" class="form-field">
        <label>{{ $t("fields.additional_timeSheet.created_date") }}</label>
        <div class="form-control bg-text">
          {{ dataForm.created_at | formatDate }}
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6" class="form-field">
        <label>{{ $t("fields.additional_timeSheet.check_in_real") }}</label>
        <div class="form-control bg-text">
          {{ dataForm.start_time_real | formatHour }}
        </div>
      </CCol>
      <CCol md="6" class="form-field">
        <label>
          {{ $t("fields.additional_timeSheet.check_in_request") }}
        </label>
        <div class="form-control bg-text">
          {{ dataForm.start_time_request | formatHour }}
        </div>
      </CCol>
    </CRow>

    <CRow>
      <CCol md="6" class="form-field">
        <label>{{ $t("fields.additional_timeSheet.check_out_real") }}</label>
        <div class="form-control bg-text">
          {{ dataForm.end_time_real | formatHour }}
        </div>
      </CCol>
      <CCol md="6" class="form-field">
        <label>
          {{ $t("fields.additional_timeSheet.check_out_request") }}
        </label>
        <div class="form-control bg-text">
          {{ dataForm.end_time_request | formatHour }}
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6" class="form-field">
        <label>
          {{ $t("fields.additional_timeSheet.reason") }}
        </label>
        <b-form-textarea
          id="textarea"
          v-model="dataForm.reason"
          rows="6"
          max-rows="6"
          readonly
        ></b-form-textarea>
      </CCol>

      <CCol md="6" class="form-field mobile-input">
        <label>{{ $t("fields.additional_timeSheet.evidence") }}</label>
        <br />
        <div v-if="image_evidence.length > 0">
          <img
            v-for="(data, index) in image_evidence"
            :key="index"
            v-img
            class="image-evidence"
            :src="data"
            width="100"
            height="100"
          />
        </div>
        <img
          v-else
          class="image-evidence"
          src="@/assets/images/no-image-available.jpg"
          width="100"
          height="100"
        />
      </CCol>
    </CRow>
    <CRow class="mt-4">
      <CCol md="12" sm="12">
        <div class="text-label">
          <div class="text-center">
            <h4 class="title-header">
              {{ $t("overtime.information_approval_ot") }}
            </h4>
          </div>
        </div>
        <div class="text-label-content">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="index">#</th>
                  <th class="text-center create-by">
                    {{ $t("overtime.employee_approval") }}
                  </th>
                  <th class="text-center create-at">
                    {{ $t("overtime.employee_approval_status") }}
                  </th>
                  <th class="text-center">
                    {{ $t("overtime.employee_approval_note") }}
                  </th>
                  <th class="text-center">
                    {{ $t("overtime.employee_approval_time") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in dataForm.request_approve"
                  :key="index"
                >
                  <th scope="row index">{{ index + 1 }}</th>
                  <td>{{ item.approved_by }}</td>
                  <td>
                    {{ $t(`overtime.employee_approval_${item.status}`) }}
                  </td>
                  <td class="comment">{{ item.comment }}</td>
                  <td>{{ item.action_at | formatDateTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </CCol>
    </CRow>
    <div
      v-if="showActionSuperiors"
    >
      <ValidationObserver ref="form">
        <CRow>
          <CCol md="12" class="form-field">
            <br />
            <label>
              {{ $t("commons.note") }}<span class="require">&nbsp;*</span>
            </label>
            <ValidationProvider v-slot="{ errors }" name="overtime.note">
              <b-form-textarea
                id="textarea"
                v-model="forms.comment"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <span v-if="errorMessage !== ''" class="error image required">
                {{ errorMessage }}
              </span>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
          <CCol md="12" class="mt-3 text-center form-data">
            <CButton
              type="button"
              class="save-info"
              @click="showApprovalConfirm()"
            >
              <span v-if="adminWaitingForApproval">{{
                $t("commons.admin_approve")
              }}</span>
              <span v-else>{{ $t("commons.approve") }}</span>
            </CButton>
            <CButton
              class="cancel-btn"
              type="button"
              @click="showRejectConfirm()"
            >
              <span v-if="adminWaitingForApproval">{{
                $t("commons.admin_unapprove")
              }}</span>
              <span v-else>{{ $t("commons.label_status_3") }}</span>
            </CButton>
          </CCol>
        </CRow>
      </ValidationObserver>
      <CusModal
        @handleCancel="hideApprovalConfirm"
        @handleOk="approveRequest"
        :title="$t('popup.commons.label_popup_timesheet_approve_title')"
        :isShow="isShowApprovalConfirm"
      >
        <div class="modal-content">
          <div class="warning-title">
            <img src="/img/icons/warning-icon.svg" alt="" /> Bạn có chắc chắn
            thực hiện hành động này không ?
          </div>
        </div>
      </CusModal>
      <CusModal
        @handleCancel="hideRejectConfirm"
        @handleOk="cancelRequest"
        :title="titlePopupCancel"
        :isShow="isShowRejectConfirm"
      >
        <div class="modal-content">
          <div class="warning-title">
            <img src="/img/icons/warning-icon.svg" alt="" /> Bạn có chắc chắn
            thực hiện hành động này không ?
          </div>
        </div>
      </CusModal>
    </div>
    <CusPopupNoti
      @handleCancel="hideNotiLackOfReview"
      @handleOk="hideNotiLackOfReview"
      title="Đơn thiếu người duyệt"
      :isShow="isShowNotiLackOfReview"
    >
        <div class="modal-content">
          <div class="warning-title">
            <img src="/img/icons/warning-icon.svg" alt="" /> Đơn thiếu người duyệt, cần thông báo tới người yêu cầu chỉnh sửa để tạo lại đơn.
          </div>
        </div>
    </CusPopupNoti>
  </div>
</template>

<script>
import CusModal from "@/components/commons/CusModal.vue";
import CusPopupNoti from "@/components/commons/CusPopupNoti.vue";
import { mapGetters, mapMutations } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";

export default {
  name: "ApprovalAdditionalTimesheet",
  props: ["id", "isSubmited"],
  metaInfo() {
    return {
      title: this.$t("page_title.page_additional_timeSheet_approval"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    CusModal,
    CusPopupNoti,
  },
  computed: {
    ...mapGetters({
      dataForm: "additional-timesheet/dataApprovalAdditionalTimeSheet",
      flagNotification: "commons/flagNotification",
    }),
    titlePopupCancel() {
      if ( this.dataForm.request_approve[0] && 
      this.dataForm.request_approve[0].level == 1 && 
      this.dataForm.request_approve[0].status == 1) {
        return this.$t("popup.commons.label_popup_timesheet_offer_title");

      } else {
        return this.$t("popup.commons.label_popup_timesheet_reject_title");
      }
    },
    showActionSuperiors() {
      return this.dataForm.status_approval_person !== undefined &&
        (this.dataForm.status_approval_person === 1 ||
        this.dataForm.status_approval_person === 4) &&
        this.dataForm.status != 3 &&
        this.dataForm.status != 2 &&
        this.dataForm.request_approve.length >= 2
    },
    adminWaitingForApproval() {
      return this.dataForm.request_approve[0] && 
      this.dataForm.request_approve[0].level == 1 && 
      this.dataForm.request_approve[0].status == 1;
    }
    //   contentPopupCancel() {
    //   if (this.dataForm.request_approve[1].level == 2) {
    //     return this.$t("popup.commons.label_popup_title_reject");
    //   } else {
    //     return this.$t("popup.commons.label_popup_title_offer");
    //   }
    // }
  },
  data() {
    return {
      errorMessage: "",
      forms: {
        status: 1,
        comment: "",
      },
      myApproveInfo: {},
      image_evidence: [],
      listEmployeeIdApproval: [],
      isShowApprovalConfirm: false,
      isShowRejectConfirm: false,
      isShowNotiLackOfReview: false,
      // isShowOfferConfirm: false,
      searchData: {
        itemsPerPage: 10,
        sortColumn: "work_date",
        sortBy: "DESC",
        status: 0,
        month: moment(),
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0,
        },
      },
    };
  },

  methods: {
    ...mapMutations("commons", ["setNotificationFlag"]),
    async getInfoApproval() {
      if (this.id) {
        this.$root.$loading.start();
        if (this.id) {
          await this.$store.dispatch(
            "additional-timesheet/showApprovalAdditionalTimeSheet",
            this.id
          );
        }
        if (this.dataForm.request_approve.length < 2) {
          this.isShowNotiLackOfReview = true;
        }
        this.$root.$loading.finish();
        this.setNotificationFlag(false);
      }
    },

    async submitOverTimeRequest() {
      this.$root.$loading.start();
      await this.$store
        .dispatch("additional-timesheet/approvalAdditionalTimeSheet", {
          data: this.forms,
          id: this.id,
        })
        .then(() => {
          let message = this.$t(
            "additional_timeSheet.message_approval_success"
          );
          this.hideRejectConfirm();
          this.hideOfferConfirm();
          this.hideApprovalConfirm();
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$emit("ok");
          this.$store.dispatch("commons/getCountRequest");
          this.getInfoApproval();
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    // async showPopupApprove() {
    //   let check = await this.validateComment();
    //   if (check) {
    //     this.$confirmModal(
    //       this.$t("popup.commons.label_popup_title_approve"),
    //       this.$t("popup.commons.label_popup_approve_title"),
    //       this.$t("popup.commons.label_confirm_button_approve"),
    //       this.$t("popup.commons.label_popup_cancel_button"),
    //       "primary"
    //     ).then((value) => {
    //       if (value) {
    //         this.forms.status = 2;
    //         this.submitOverTimeRequest();
    //       }
    //     });
    //   }
    // },

    async showApprovalConfirm() {
      let check = await this.validateComment();
      if (check) {
        this.isShowApprovalConfirm = true;
      }
    },

    async showRejectConfirm() {
      let check = await this.validateComment();
      if (check && this.forms.comment !== "") {
        this.isShowRejectConfirm = true;
        return;
      }
      this.isShowRejectConfirm = false;
    },

    async approveRequest() {
      let check = await this.validateComment();
      if (check) {
        this.forms.status = 2;
        await this.submitOverTimeRequest();
        // if (this.$route.name == 'Additional Timesheet') {
        //   this.fetchApprovalAdditionTimeSheetData();
        // }
      }
    },

    validateComment() {
      this.errorMessage = "";
      if (this.forms.comment === "") {
        this.errorMessage =
          this.$t("commons.note") + " " + this.$t("error.require");
        return false;
      }
      return true;
    },

    hideNotiLackOfReview() {
      this.isShowNotiLackOfReview = false;
      this.$emit('showNotiLackOfReview');
    },

    // async showPopupCancel() {
    //   let check = await this.validateComment();
    //   if (check) {
    //     if (this.dataForm.request_approve[1].level == 2) {
    //       this.$confirmModal(
    //         this.$t("popup.commons.label_popup_title_reject"),
    //         this.$t("popup.commons.label_popup_reject_title"),
    //         this.$t("popup.commons.label_popup_title_cancel_approve"),
    //         this.$t("popup.commons.label_cancel_button"),
    //         "danger"
    //       ).then((value) => {
    //         if (value) {
    //           this.forms.status = 3;
    //           this.submitOverTimeRequest();
    //         }
    //       });
    //     } else {
    //       this.$confirmModal(
    //         this.$t("popup.commons.label_popup_title_offer"),
    //         this.$t("popup.commons.label_popup_offer_title"),
    //         this.$t("popup.commons.label_popup_title_cancel_approve"),
    //         this.$t("popup.commons.label_cancel_button"),
    //         "danger"
    //       ).then((value) => {
    //         if (value) {
    //           this.forms.status = 5;
    //           this.submitOverTimeRequest();
    //         }
    //       });
    //     }
    //   }
    // },
    async cancelRequest() {
      let check = await this.validateComment();
      if (check) {
        if (this.dataForm.request_approve[0] && this.dataForm.request_approve[0].level == 1 && this.dataForm.request_approve[0].status != 1) {
          this.forms.status = 3;
          await this.submitOverTimeRequest();
        } else {
          this.forms.status = 5;
          await this.submitOverTimeRequest();
        }
        // if (this.$route.name == 'Additional Timesheet') {
        //   this.fetchApprovalAdditionTimeSheetData();
        // }
      }
    },
    hideOfferConfirm() {
      this.isShowOfferConfirm = false;
    },

    hideApprovalConfirm() {
      this.isShowApprovalConfirm = false;
    },

    hideRejectConfirm() {
      this.isShowRejectConfirm = false;
    },
    async fetchApprovalAdditionTimeSheetData() {
      await this.$store.dispatch(
        "additional-timesheet/listAdditionalTimeSheetApproval",
        this.$route.name == 'Additional Timesheet' && Object.keys(this.$route.query).length ? this.$route.query :
        {
          itemsPerPage: this.searchData.itemsPerPage,
          currentPage: this.searchData.paginate.currentPage,
          sortColumn: this.searchData.sortColumn,
          sortBy: this.searchData.sortBy,
          status: this.searchData.status ? parseInt(this.searchData.status) : null,
          month: this.searchData.month.format('MM/YYYY')
        }
      );
      this.searchData.paginate = this.pagination;
    },
  },
  async created() {
    await this.getInfoApproval();
    var tempData = { ...this.dataForm };
    delete tempData.img_evidence;
    delete tempData.img_evidence2;
    tempData.img_evidence = [];
    if (this.dataForm.img_evidence) {
      this.image_evidence.push(this.dataForm.img_evidence);
      tempData.img_evidence.push(this.dataForm.img_evidence);
    }
    if (this.dataForm.img_evidence2) {
      this.image_evidence.push(this.dataForm.img_evidence2);
      tempData.img_evidence.push(this.dataForm.img_evidence2);
    }
  },

  watch: {
    async flagNotification(value) {
      if (value) {
        this.listEmployeeIdApproval = [];
        await this.getInfoApproval();
      }
    },
  },
};
</script>
